<template>
  <FormInput
    ref="field"
    type="tel"
    :validations="phoneValidations"
    v-bind="_props"
    v-on="$listeners"
    v-mask="{ mask, tokens }"
  />
</template>

<script>
import mask from 'vue-the-mask/src/directive'
import { isPhoneNumber } from '@/helpers/validation'
import { isUs } from '@/helpers/address'
import formFieldInterfaceMixin from '@/components/_shared/Form/form-field-interface-mixin'
import FormInput from '@/components/_shared/Form/Input/FormInput.vue'
import propsInput from '@/components/_shared/Form/Input/props-input'

const DEFAULT_MASK = '****************************************' // 40 digits to align with the salesforce max length
const US_MASK = '(###) ###-####'

export default {
  name: 'PhoneFormInput',
  components: { FormInput },
  directives: { mask },
  mixins: [formFieldInterfaceMixin],

  props: {
    ...propsInput,
    countryIso: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      phoneValidation: {
        validator: this.isPhoneValid,
        message: this.$t('errors.invalid_field'),
      },
      tokens: {
        '*': { pattern: /[+()-\s./0-9]/ },
        '#': { pattern: /\d/ },
      },
    }
  },

  computed: {
    phoneValidations() {
      return [...(this.validations ? this.validations : []), this.phoneValidation]
    },

    mask() {
      return isUs(this.countryIso) ? US_MASK : DEFAULT_MASK
    },
  },

  methods: {
    isPhoneValid(value) {
      return isPhoneNumber(value) || (!value && !this.isRequired)
    },
  },
}
</script>
